<template>
  <section class="timeline-section" :style="section.config.style">
    <div class="container">
      <div class="section-title">
        <h2>{{ section.config.title }}</h2>
        <p>{{ section.config.subtitle }}</p>
      </div>
      
      <div class="timeline-container" :class="[`layout-${section.config.layout}`]">
        <div v-for="(item, index) in section.config.items" :key="item.id" class="timeline-item">
          <div class="timeline-marker">
            <span class="timeline-icon">{{ item.icon }}</span>
          </div>
          <div class="timeline-content" :class="{ 'right': index % 2 === 1 && section.config.layout === 'alternating' }">
            <div class="timeline-year">{{ item.year }}</div>
            <h3 class="timeline-title">{{ item.title }}</h3>
            <p class="timeline-description">{{ item.description }}</p>
            <span class="timeline-type" v-if="item.type">{{ item.type }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Timeline',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.timeline-section {
  padding: 80px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
}

.section-title p {
  font-size: 1.125rem;
  color: var(--gray-600);
}

/* 时间线容器 */
.timeline-container {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}

.layout-alternating::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--gradient-primary);
  transform: translateX(-50%);
  border-radius: 1.5px;
}

.layout-left::before {
  content: '';
  position: absolute;
  left: 1.5rem;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--gradient-primary);
  border-radius: 1.5px;
}

.timeline-item {
  position: relative;
  margin-bottom: 3rem;
}

/* 时间线标记 */
.timeline-marker {
  position: absolute;
  width: 3rem;
  height: 3rem;
  background: white;
  border: 3px solid var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: var(--shadow-md);
}

.layout-alternating .timeline-marker {
  left: 50%;
  transform: translateX(-50%);
}

.layout-left .timeline-marker {
  left: 0;
}

.timeline-icon {
  font-size: 1.2rem;
}

/* 时间线内容 */
.timeline-content {
  background: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  position: relative;
  border: 1px solid var(--gray-200);
  transition: all 0.3s ease;
}

.timeline-content:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* 交替布局 */
.layout-alternating .timeline-content {
  width: calc(50% - 3rem);
  margin-left: 3rem;
}

.layout-alternating .timeline-content.right {
  margin-left: auto;
  margin-right: 3rem;
}

/* 左侧布局 */
.layout-left .timeline-content {
  margin-left: 4rem;
}

/* 内容箭头 */
.layout-alternating .timeline-content::before {
  content: '';
  position: absolute;
  top: 1.5rem;
  width: 0;
  height: 0;
  border: 8px solid transparent;
}

.layout-alternating .timeline-content:not(.right)::before {
  right: -16px;
  border-left-color: white;
}

.layout-alternating .timeline-content.right::before {
  left: -16px;
  border-right-color: white;
}

.layout-left .timeline-content::before {
  content: '';
  position: absolute;
  top: 1.5rem;
  left: -16px;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-right-color: white;
}

.timeline-year {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.timeline-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.75rem;
}

.timeline-description {
  color: var(--gray-600);
  line-height: 1.6;
  margin-bottom: 1rem;
}

.timeline-type {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: var(--primary-color);
  color: white;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .layout-alternating::before {
    left: 1.5rem;
  }

  .layout-alternating .timeline-marker {
    left: 1.5rem;
    transform: none;
  }

  .layout-alternating .timeline-content,
  .layout-alternating .timeline-content.right {
    width: calc(100% - 4rem);
    margin-left: 4rem;
    margin-right: 0;
  }

  .layout-alternating .timeline-content::before,
  .layout-alternating .timeline-content.right::before {
    left: -16px;
    border-right-color: white;
    border-left-color: transparent;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/Timeline.vue